// @ts-nocheck: converted from JS

import { FieldTypes, groupTitleValue } from '@/components/FormBuilder/Item.utils';
import { DateTimeRenderer } from '@/components/UI/DateRenderers/DateRenderers';
import Link from '@/components/UI/Link';
import { web as webRoute } from '@/support/route';

export const isSelectField = (fieldType, fieldOptions = []) =>
  (fieldType?.toLowerCase() === FieldTypes.select && fieldOptions.length > 3) ||
  fieldType?.toLowerCase() === FieldTypes.multi_select;

export const isRadioField = (fieldType, fieldOptions = []) =>
  (fieldType?.toLowerCase() === FieldTypes.select && fieldOptions.length <= 3) ||
  fieldType?.toLowerCase() === FieldTypes.radio;

const isGroupTitle = (formItem) => formItem.type === groupTitleValue;

export const generateColumns = () => [
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
    size: 50,
    isVisible: true,
    enableSorting: true,
    cell: ({ row }) => {
      return (
        <Link
          className="link blue"
          to={webRoute('team.studies.requests.edit', {
            requestTemplate: row.original?.id,
          })}
        >
          {row.original.name}
        </Link>
      );
    },
  },
  {
    id: 'created_at',
    accessorKey: 'created_at',
    header: 'Created',
    size: 50,
    isVisible: true,
    enableSorting: true,
    cell: ({ row }) => <DateTimeRenderer value={row.original.created_at} />,
  },
];

/**
 * Convert the FormBuilder submit data into the format of an approval object
 * @param formData
 */
export const mapFormBuilderDataToRequestData = (formData) => {
  const buildNewGroup = (label) => {
    const group = {
      fields: [],
    };
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (label) {
      group.label = label;
    }
    return group;
  };
  const buildRequestField = (formItem, isRadio, isSelect) => {
    const requestField = {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      type: isRadio ? FieldTypes.radio : formItem.type,
      label: formItem.label,
      required: formItem.required ?? true,
    };
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (isSelect || isRadio) {
      requestField.options = formItem.options;
    }
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (formItem.hint) {
      requestField.hint = formItem.hint;
    }
    return requestField;
  };
  const groupFormItemsReducer = (groups, formItem) => {
    if (isGroupTitle(formItem)) {
      groups.push(buildNewGroup(formItem.label));
      return groups;
    }
    const isSelect = isSelectField(formItem.type, formItem.options);
    const isRadio = isRadioField(formItem.type, formItem.options);

    const requestField = buildRequestField(formItem, isRadio, isSelect);
    const group = groups[groups.length - 1];
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!group) {
      groups.push(buildNewGroup());
    }

    groups[groups.length - 1].fields.push(requestField);
    return groups;
  };
  const hasFields = (group) => Boolean(group.fields?.length);
  const groups = formData.reduce(groupFormItemsReducer, []).filter(hasFields);
  return {
    groups,
  };
};

/**
 * Convert an request object into the structure to populate a FormBuilder value
 * @param requestForm
 */
export const mapRequestDataToFormBuilderData = (requestForm) => {
  const buildGroup = (label) => ({
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    label: label || '',
    type: groupTitleValue,
  });
  const buildFormItem = (requestField) => {
    const isSelect = isSelectField(requestField.type, requestField.options);
    const isRadio = isRadioField(requestField.type, requestField.options);
    const mappedFormItem = {
      type: isRadio ? FieldTypes.radio : requestField.type,
      label: requestField.label,
      required: requestField.required ?? true,
    };
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (requestField.hint) {
      mappedFormItem.hint = requestField.hint;
    }
    if (isSelect || isRadio) {
      mappedFormItem.options = requestField.options;
    }
    return mappedFormItem;
  };
  const groupsToFormItemsReducer = (formItems, group) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (group.label) {
      formItems.push(buildGroup(group.label));
    }
    const fields = group.fields.map(buildFormItem);
    formItems.push(...fields);
    return formItems;
  };

  return requestForm.groups.reduce(groupsToFormItemsReducer, []);
};
